import React, { Component } from 'react';
import styled from 'styled-components';
import Title from '../../components/Title';
import { colors } from '../../styles/colors';
import FlightChangeForm from './FlightChangeForm';
import Modal from '../../components/Modal';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import LoadMask from '../../components/LoadMask';
import { azulGet } from '../../services';
// import { SUGGESTED_FLIGHTS_LIST } from '../../consts/MOCK_DATA';
import { devices } from '../../styles/breakpoints';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;

  @media ${devices.desktop} {
    max-width: 1170px;
    margin: 0 auto;
  }
`;

const GrayText = styled.p`
  font-size: 14px;
  color: ${colors.GRAY_DARKEST};
  padding-top: 16px;
  padding-bottom: 16px;

  @media ${devices.desktop} {
    font-size: 20px;
  }
`;

const Bold = styled.span`
  font-weight: bold;
`;

const AttentionIcon = styled(Icon)`
  font-size: 48px;
  margin-bottom: 16px;
  color: ${colors.BRAND_PRIMARY};
`;

const ModalTextAndIconContainer = styled.div`
  margin: 20px;
  color: ${colors.BRAND_PRIMARY};
  text-align: center;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ModalActionsContainer = styled.div`
  margin: 0px 20px;
`;

export default class FlightChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      error: '',
      isOpen: false,
      hasNoAction: false,
      flights: []
    };
  }

  componentDidMount() {
    this._fethFlightsSuggestionFlights();
  }

  _refreshModalTimer = () => {
    setTimeout(() => {
      this.setState({
        isOpen: true,
        error: 'Esse voo não está mais disponível.'
      });
    }, 300000);
  };

  _refreshFlightsAndTimer = () => {
    this.setState({ isOpen: false });
    this._fethFlightsSuggestionFlights();
  };

  _fethFlightsSuggestionFlights = async () => {
    const { history } = this.props;
    const { pnr } = history.location.state;
    const url = `/SelfService/${pnr}/suggestion-flights`;
    try {
      this.setState({ isLoading: true });
      const { success, data, notifications } = await azulGet(url);

      // const { success, data, notifications } = SUGGESTED_FLIGHTS_LIST;

      if (success) {
        this._handleFetchSuccess(data);
      } else {
        this._handleFetchError(notifications[0].value);
      }

      console.log('fetchSuggestionFlights', { success, data, notifications });
    } catch (error) {
      console.log(error.message);
      this.setState({ isLoading: false, error: error.message });
    }
  };

  _handleFetchSuccess = data => {
    const { flightSuggestion, success, message } = data;

    if (success) {
      this._refreshModalTimer();

      return this.setState({
        isLoading: false,
        error: '',
        flights: flightSuggestion
      });
    } else {
      return this.setState({
        isLoading: false,
        error: message,
        isOpen: true,
        hasNoAction: true,
        flights: []
      });
    }
  };

  _handleFetchError = error => {
    return this.setState({
      isLoading: false,
      error,
      flights: []
    });
  };

  _handleLoading = status => {
    this.setState({ isLoading: status });
  };

  render() {
    const { history } = this.props;
    const { pnr } = history.location.state;
    const { isOpen, hasNoAction, flights, isLoading, error } = this.state;

    if (isLoading) return <LoadMask />;

    return (
      <Container>
        <Title>Alteração de voo</Title>
        <GrayText>
          <Bold>Selecione o seu novo voo.</Bold>
          <br />
          <br />
          Ah! E não se preocupe, todos os passageiros que estão na sua reserva
          também serão reacomodados.
          <br />
          <br />
          <Bold>Confira abaixo as novas sugestões de voo:</Bold>
        </GrayText>
        <FlightChangeForm
          history={history}
          pnr={pnr}
          flights={flights}
          onLoading={this._handleLoading}
        />
        <Modal
          isOpen={isOpen}
          onDismiss={hasNoAction ? () => {} : this._refreshFlightsAndTimer}
        >
          <ModalTextAndIconContainer>
            <AttentionIcon name="attention" />
            {error && <p>{error}</p>}

            {hasNoAction ? (
              <p>Por favor, dirija-se ao balcão para obter mais informações.</p>
            ) : (
              <p>Por favor, selecione outro voo da lista.</p>
            )}
          </ModalTextAndIconContainer>
          {!hasNoAction && (
            <ModalActionsContainer>
              <Button primary onClick={this._refreshFlightsAndTimer}>
                Escolher outro voo
              </Button>
            </ModalActionsContainer>
          )}
        </Modal>
      </Container>
    );
  }
}
